import FlightPlanTable from './FlightPlanTable.component';

export default FlightPlanTable;
